import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaMapMarkerAlt } from "react-icons/fa";
import logo from "../../../assets/logo.png";
import { API_BASE_URL } from "../../../config";

export default function RoundsListings() {
  const navigate = useNavigate();
   const isMobile = window.innerWidth <= 768;
  const [listings, setListings] = useState([]);
  const [filters, setFilters] = useState({
    state: "",
  });


  const options = {
    state: ["NSW", "VIC", "QLD", "SA", "WA", "TAS", "NT", "ACT"],
  };

  // ============================
  // FETCH ROUND LISTINGS
  // ============================
  useEffect(() => {
    fetch(`${API_BASE_URL}/api/cleaning/rounds/list`)

      .then((res) => res.json())
      .then((data) => {
        if (data.success) setListings(data.listings);
      })
      .catch((err) =>
        console.error("❌ Failed to load round listings:", err)
      );
  }, [API_BASE_URL]);

  // ============================
  // FILTER LIST
  // ============================
  const filteredListings = listings.filter((l) => {
    const matchState = !filters.state || l.state === filters.state;
    return matchState;
  });

  const cardStyle = {
    backgroundColor: "#fff",
    borderRadius: "12px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
    overflow: "hidden",
    position: "relative",
    transition: "transform 0.2s ease",
  };

  const viewButton = {
    width: "100%",
    marginTop: "8px",
    backgroundColor: "#2e7d32",
    color: "#fff",
    padding: "10px",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
  };

  const selectStyle = {
    width: "100%",
    padding: "10px",
    marginBottom: "15px",
    borderRadius: "8px",
    border: "1px solid #ccc",
    fontSize: "1rem",
  };

  const buttonStyle = {
    width: "100%",
    padding: "12px",
    backgroundColor: "#2e7d32",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "bold",
    marginBottom: "10px",
  };

  return (
    <div
  style={{
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    minHeight: "100vh",
    backgroundColor: "#f4f7f9",
  }}
>
      
      {/* SIDEBAR */}
     <aside
  style={{
    width: isMobile ? "100%" : "250px",
    backgroundColor: "#2e7d32",
    color: "#fff",
    padding: isMobile ? "4px 6px" : "20px",
    height: isMobile ? "auto" : "100vh",
    overflowY: isMobile ? "visible" : "auto",
    textAlign: "center",
  }}
>
  <img
    src={logo}
    alt="Client Exchange Logo"
    style={{ width: "140px", margin: "0 auto 25px" }}
  />

  <Link to="/">
    <button style={buttonStyle}>Home</button>
  </Link>

  <div style={{ marginTop: "20px", textAlign: "left" }}>

    <label style={{ fontWeight: "bold" }}>View:</label>
    <select
      onChange={(e) => {
        const view = e.target.value;

        if (view === "listings") navigate("/cleaning/listings");
        if (view === "swaps") navigate("/cleaning/swaps");
        if (view === "rounds") navigate("/cleaning/rounds");
      }}
      style={selectStyle}
    >
      <option value="rounds">Rounds</option>
      <option value="listings">Listings</option>
      <option value="swaps">Swaps</option>
    </select>

    <label style={{ fontWeight: "bold" }}>Category:</label>
    <select
      onChange={(e) => {
        const category = e.target.value;

        if (category === "Lawn Mowing") navigate("/listings");
        if (category === "Cleaning") navigate("/cleaning/listings");
        if (category === "Pool Care") navigate("/poolcare/listings");
      }}
      style={selectStyle}
    >
      <option value="Cleaning">Cleaning</option>
      <option value="Lawn Mowing">Lawn Mowing</option>
      <option value="Pool Care">Pool Care</option>
    </select>

    <label style={{ fontWeight: "bold" }}>State:</label>
    <select
      value={filters.state}
      onChange={(e) => setFilters({ state: e.target.value })}
      style={selectStyle}
    >
      <option value="">All</option>
      {options.state.map((opt) => (
        <option key={opt} value={opt}>
          {opt}
        </option>
      ))}
    </select>

    <label style={{ fontWeight: "bold" }}>Postcode:</label>
    <input
      type="text"
      placeholder="Enter Postcode"
      style={selectStyle}
    />

    <button
      onClick={() => setFilters({ state: "" })}
      style={{
        ...buttonStyle,
        backgroundColor: "#d32f2f",
      }}
    >
      Reset Filters
    </button>

  </div>
</aside>

      {/* MAIN LISTING GRID */}
      <main style={{ flex: 1, padding: "20px" }}>
        <div
          style={{
            textAlign: "center",
            fontSize: "1.5rem",
            fontWeight: "bold",
            marginBottom: "15px",
            color: "#2e7d32",
          }}
        >
          Cleaning Rounds — {" "}
          <span style={{ color: "#333", fontWeight: "normal" }}>
            {filteredListings.length} Results
          </span>
        </div>

        {filteredListings.length === 0 ? (
          <p style={{ textAlign: "center" }}>No listings found.</p>
        ) : (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              gap: "20px",
            }}
          >
            {filteredListings.map((listing) => (
              <div
                key={listing.id}
                style={cardStyle}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.transform = "translateY(-5px)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.transform = "translateY(0)")
                }
              >
                {/* IMAGE */}
                <img
                  src="/images/Cleaning.jpg"
                  alt="round"
                  style={{
                    width: "100%",
                    height: "200px",
                    objectFit: "cover",
                  }}
                />

                {/* CONTENT */}
                <div style={{ padding: "12px 15px" }}>
                  <h2
                    style={{
                      margin: 0,
                      color: "#333",
                      fontSize: "1.2rem",
                      fontWeight: "600",
                    }}
                  >
                    {listing.title}
                  </h2>

                  <p style={{ margin: "4px 0 10px 0", color: "#777" }}>
                    ID: <strong>RND-{listing.id}</strong>
                  </p>

                  <div style={{ color: "#2e7d32", fontWeight: "bold" }}>
                    Asking Price: ${Number(listing.price).toLocaleString()}
                  </div>

                  <div style={{ marginTop: "6px", color: "#444" }}>
                    <strong>Total Cut Value:</strong>{" "}
                    ${Number(listing.total_cut_value).toLocaleString()}
                  </div>

                  <div style={{ marginTop: "3px", color: "#444" }}>
                    <strong>Yearly Revenue:</strong>{" "}
                    ${Number(listing.yearly_revenue).toLocaleString()}
                  </div>

                  <div style={{ color: "#555", marginTop: "5px" }}>
                    <FaMapMarkerAlt color="#d32f2f" />{" "}
                    {listing.suburb}, {listing.state}
                  </div>

                  <Link to={`/cleaning/rounds/${listing.id}`}>

                    <button style={viewButton}>View Details</button>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
